/** Browser diagnostics must never snapshot Jotform contact or recovery payloads.
 * Recognize only this integration's API namespace (including the /b proxy). */
export function isJotformApiUrl(value: string): boolean {
  try {
    const path = new URL(value, 'https://pointcraft.invalid').pathname;
    return (
      /^\/(?:b\/)?api\/(?:public\/experiences|business\/payforms|admin\/public-experiences|services)\//.test(
        path
      ) && /\/jotform(?:-connections)?(?:\/|$)/.test(path)
    );
  } catch {
    return false;
  }
}

export function isJotformSensitiveKey(value: string): boolean {
  const key = value.toLowerCase().replace(/[^a-z0-9]/g, '');
  return [
    'proof',
    'attemptproof',
    'attemptproofhash',
    'xjotformattemptproof',
    'capability',
    'checkoutcapability',
    'xcheckoutcapability',
    'popupcapability',
    'xjotformpopupcapability',
    'paymentreceiptref',
    'handofftoken',
    'nonce',
    'endpointtoken',
  ].includes(key);
}

/** Covers both structured payloads and credentials pasted into messages. Public
 * integration/request/Session IDs without a client secret remain readable. */
export function redactJotformText(value: string, replacement: string): string {
  return value
    .replace(/\bjf[aphrw]_[A-Za-z0-9_-]+/g, replacement)
    .replace(/\b(?:cs|seti|pi)_[A-Za-z0-9_]+_secret_[A-Za-z0-9_]+\b/g, replacement)
    .replace(
      /\b((?:x[-_]?)?(?:jotform[-_]?)?attempt[-_]?proof(?:hash)?|(?:x[-_]?)?(?:jotform[-_]?)?(?:checkout[-_]?|popup[-_]?)?capability|payment[-_]?receipt[-_]?ref|handoff[-_]?token|endpoint[-_]?token|nonce)\b(\s*["']?\s*[:=]\s*)("(?:\\.|[^"\\])*"?|'(?:\\.|[^'\\])*'?|\[redacted\]|[^\s,;&}\]"']+)/gi,
      (_match, key: string, separator: string, secret: string) => {
        const quote = ['"', "'"].includes(secret[0]) ? secret[0] : '';
        return `${key}${separator}${quote}${replacement}${quote}`;
      }
    );
}
